import { useEffect, useRef } from "react";

export function useMobileSidebar(open: boolean) {
  const ref = useRef<HTMLElement>(null);
  useEffect(() => {
    const sidebar = ref.current;
    if (!sidebar) return;
    const media = window.matchMedia("(max-width: 780px)");
    const sync = () => { sidebar.inert = media.matches && !open; };
    sync(); media.addEventListener("change", sync);
    return () => { media.removeEventListener("change", sync); sidebar.inert = false; };
  }, [open]);
  useEffect(() => {
    const sidebar = ref.current;
    if (!open || !sidebar) return;
    const main = document.querySelector<HTMLElement>(".main-panel");
    const previous = document.activeElement as HTMLElement | null;
    const focusable = () => [...sidebar.querySelectorAll<HTMLElement>('button:not(:disabled), a[href], input, select, summary, [tabindex="0"]')].filter((element) => element.getClientRects().length);
    focusable()[0]?.focus();
    if (main) main.inert = true;
    const trap = (event: KeyboardEvent) => {
      if (event.key !== "Tab" || document.querySelector("dialog[open]")) return;
      const items = focusable(), first = items[0], last = items.at(-1);
      if (!first || !last) return;
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    };
    sidebar.addEventListener("keydown", trap);
    return () => { if (main) main.inert = false; sidebar.removeEventListener("keydown", trap); if (previous?.isConnected) previous.focus(); };
  }, [open]);
  return ref;
}
